export const Endpoint = () => `/api/v3/celery/unscheduledbotnameslist`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'unscheduledTasks'] as const;
export type Payload = never;
export type Response = string[];
